import { useEffect } from "react"
import { BrowserRouter as Router, useLocation } from "react-router-dom"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { MainRouter } from "./routes/MainRouter";
// import ChatbotMount from './components/ChatbotMount'
import { Toaster } from "sonner";

const queryClient = new QueryClient();

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [pathname]);

  return null;
};

export const App = () => (
  <QueryClientProvider client={queryClient}>
    <Router>
      <ScrollToTop />
      <Toaster richColors />
      <MainRouter />
      {/* <ChatbotMount /> */}
    </Router>
  </QueryClientProvider>
)
